import type { ExternalHref } from "@qendo/util";

export const API_HOST = process.env.EXPO_PUBLIC_API_HOST ?? "";

export const QENDO_LINKS: Record<string, ExternalHref> = {
    contact: "https://www.qendo.org.au/contact-us",
    feedback: "https://www.qendo.org.au/feedback",
    about: "https://www.qendo.org.au/",
    privacy: "https://www.qendo.org.au/privacy-policy",
    terms: "https://www.qendo.org.au/app-terms-and-conditions",
    report: "https://www.qendo.org.au/report",
    community: "https://www.qendo.org.au/community",
    events: "https://www.qendo.org.au/upcoming-events",
    exercise: "https://www.qendo.org.au/exercise",
    nutrition: "https://www.qendo.org.au/nutrition",
    carer_support: "https://www.qendo.org.au/carer-support",
    pain: "https://www.qendo.org.au/pain",
    mentor_program: "https://www.qendo.org.au/mentorprogram",
    mentor_signup:
        "https://docs.google.com/forms/d/e/1FAIpQLSexSgsrv96TNQzmY5rUE-oxsbLtfxt87_9ZFz7MwB-sI0EBJQ/viewform?usp=sharing",
    mentee_signup:
        "https://docs.google.com/forms/d/e/1FAIpQLSf-VxhQLPM83o_KqAwbl4lI_fuGlRPDu6_6GAtTsuWxkHfPJA/viewform?usp=sharing",
    manage_endo: "https://www.youtube.com/playlist?list=PLKZYoldUPiolx1ZPogZQ5tgzLhilpRE6H",
    manage_endo_embed: "https://qendoapp.com/embeds/manage-endo.html",
};
